import React, { useState } from "react";
import useLogout from "../../hooks/useLogout";
import { useNavigate } from "react-router-dom";

export default function PowerBIForm() {
    const navigate = useNavigate();
    const logout = useLogout();

    const signOut = async () => {
        await logout();
        navigate('/login');
    }

    return (
        <div className="insight">
            <header className="insight-header">
                <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
                <div className="navbar">
                    <a className="navbar-item" href="/AI">
                        <div className="top-nav-item">AI</div>
                    </a>
                    <a className="navbar-item" href="/insight">
                        <div className="top-nav-item">Insight</div>
                    </a>
                    <a className="navbar-item" href="/power-bi">
                        <div className="top-nav-item">power BI</div>
                    </a>
                </div>
                <button className="sign-out-button" onClick={signOut}>Sign Out</button>
            </header>
            <body className="insight-body">power BI</body>
            <footer className="insight-footer"></footer>
        </div>
    );
}
